export const handleBackButton = (e) => {
  e.preventDefault()
  e.returnValue = ''
}

export const removeUnloadEventListener = () =>
  window.removeEventListener('beforeunload', handleBackButton)
